export default "/fonts/line-awesome.woff2?4b43b038741cb489a5027a5c8ab14fb9";